import { Injectable } from '@angular/core';
import { GetVirtualCardCvvCommand } from '@core/commands/get-virtual-card-сvv.command';
import { AlertService } from '@core/services/alert/alert.service';
import { LoadingService } from '@core/services/loading/loading.service';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VirtualCvvCommand extends BaseProductCommand {
  readonly type = 'virtualCVV';
  readonly title = 'Запросить CVV';
  readonly icon = 'key';
  readonly productType = ProductTypes.CARD;
  readonly isInfoAction = false;
  readonly settingsNames = undefined;
  readonly order = 8; // Закомментирован в generate-product-actions.ts

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private getVirtualCardCvv: GetVirtualCardCvvCommand,
    private loadingService: LoadingService,
    private alertService: AlertService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.loadingService.showLoader(true);
    this.getVirtualCardCvv.execute({ id: context.data.id }).pipe(
      finalize(() => this.loadingService.showLoader(false))
    )
    .subscribe(
      (message) => {
        this.alertService.showInfoAlert(message);
      },
      (error) => {
        if (error) {
          this.alertService.showErrorAlert(error);
        }
      }
    );
  }

  protected checkAdditionalAvailability(_context: IProductCommandContext): Observable<boolean> | boolean {
    // Команда virtualCVV временно отключена (закомментирована в generate-product-actions.ts)
    // Всегда возвращаем false для скрытия команды
    return false;
  }
}

